import { http } from '../../util';

/* APIs */
const requestInvitations = async accountNumber => {
  const { data } = await http.get(`${import.meta.env.VITE_API_URL}/v1/user/invite/${accountNumber}/details`);

  const countsIds = {
    counts: {
      expiredInvitations: data.inviteStats.expired,
      pendingInvitations: data.invites.length - data.inviteStats.expired
    },
    byId: {}
  };

  for (let i = 0; i < data.invites.length; i++) {
    const invite = data.invites[i];

    countsIds.byId[invite.id] = {
      id: invite.id,
      email: invite.email,
      role: invite.role,
      token: invite.token,
      status: invite.status,
      departments: invite.departments.map(departmentNumber => {
        return departmentNumber.toString();
      }),
      accountNumber: invite.accountNumber,
      createTimestamp: invite.createTimestamp
    };
  }

  return countsIds;
};

const requestInvitationCounts = async accountNumber => {
  const { data } = await http.get(`${import.meta.env.VITE_API_URL}/v1/user/invite/${accountNumber}/details`);

  const counts = {
    expiredInvitations: data.inviteStats.expired,
    pendingInvitations: data.invites.length - data.inviteStats.expired
  };

  return { counts };
};

const createInvitation = async ({ accountNumber, departmentNumbers, email, language, role }) => {
  return http.post(`${import.meta.env.VITE_API2_URL}/v1/users/invite`, {
    accountNumber,
    departmentNumbers,
    email,
    language,
    role
  });
};

/* ACTIONS */
const cancelInvitation = {
  name: 'CANCEL_INVITATION_PROCESS'
};

const deselectInvitation = {
  name: 'DESELECT_INVITATION'
};

const filterInvitations = {
  name: 'FILTER_INVITATIONS',
  action: filter => filter
};

const getInvitations = {
  name: 'GET_INVITATIONS',
  action: async accountNumber => {
    return requestInvitations(accountNumber);
  }
};

const getInvitationCounts = {
  name: 'GET_INVITATION_COUNTS',
  action: async accountNumber => {
    return requestInvitationCounts(accountNumber);
  }
};

const issueInvitation = {
  name: 'ISSUE_INVITATION',
  action: async ({ accountNumber, departmentNumbers, email, language, role }) => {
    await createInvitation({ accountNumber, departmentNumbers, email, language, role });

    return requestInvitations(accountNumber);
  }
};

const resetInvitations = {
  name: 'RESET_INVITATIONS'
};

const selectInvitation = {
  name: 'SELECT_INVITATION',
  action: invitationId => invitationId
};

const selectInvitations = {
  name: 'SELECT_INVITATIONS'
};

const sortInvitations = {
  name: 'SORT_INVITATIONS',
  action: sort => sort
};

const startInvitationProcess = {
  name: 'START_INVITATION_PROCESS'
};

export const invitationsActions = {
  cancelInvitation,
  deselectInvitation,
  filterInvitations,
  getInvitations,
  getInvitationCounts,
  issueInvitation,
  resetInvitations,
  selectInvitation,
  selectInvitations,
  sortInvitations,
  startInvitationProcess
};
